import NavBar from "../header/NavBar";
import Banner from "../header/Banner";
import OurServices from "../components/OurServices";
import Footer from "../components/Footer";
import RecentJobs from "../components/RecentJobs";
import Testimonials from "../components/Testimonials";

function Index() {
  return (
    <>
      <Banner />
      {/* <OurServices /> */}
      <RecentJobs />
      <Testimonials />
      <Footer />
    </>
  );
}

export default Index;
